// extracted by mini-css-extract-plugin
export default {"progress":"style_progress__AaGer"};